export const FPG_PAGE_ROUTE = '/en-us/tools/incentive-tool';
export const LANDING_PAGE_ROUTE = '/';
export const DETAILS_PAGE_ROUTE = '/details';
export const RESIDENTIAL_INCENTIVES_DETAILS_PAGE_ROUTE = '/residential-incentive-info';
export const EXPORT_PDF_PAGE_COMMERCIAL_ROUTE = '/commercial/export-pdf';
export const EXPORT_PDF_PAGE_RESIDENTIAL_ROUTE = '/residential/export-pdf';
